import { render, staticRenderFns } from "./Allfeedback.vue?vue&type=template&id=c80a0e86&"
import script from "./Allfeedback.vue?vue&type=script&lang=js&"
export * from "./Allfeedback.vue?vue&type=script&lang=js&"
import style0 from "./Allfeedback.vue?vue&type=style&index=0&id=c80a0e86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports